const Sponsors = () => {
  return <h1>Sponsors</h1>;
};
export default Sponsors;
